<template>
  <div class="pagination">
    <div
      class="page-item"  
      :class="{disabled: currentPage == 1}"
      @click="goto(currentPage - 1)">
      <a class="page-link" tabindex="-1">&lt; {{$t('home.components.pagination.prev')}} </a>
    </div>
    <div
      class="page-item"
      :class="{active:currentPage == pageNumber}"
      v-for="pageNumber in totalPages"
      :key="pageNumber"
      v-show="Math.abs(pageNumber - currentPage) <= 2 || pageNumber == totalPages || pageNumber == totalPages - 2 || pageNumber == 1 || pageNumber == 2"
    >
      <a class="page-link" v-if="pageNumber == 2 && Math.abs(pageNumber - currentPage) >= 2">...</a>
      <a
        class="page-link"
        v-else-if="pageNumber == totalPages - 2 && Math.abs(pageNumber - currentPage) >= 2"
      >...</a>
      <a class="page-link" v-else @click="goto(pageNumber)">{{pageNumber}}</a>
    </div>
    <div class="page-item" :class="{disabled: currentPage == totalPages}">
      <a
        class="page-link"
        @click="goto(currentPage + 1)"
      >{{$t('home.components.pagination.next')}}  &gt;</a>
    </div>

    <div class="page-item">
      <span class="current-page">{{currentPage}}</span>
      <span class="total-page">/{{totalPages}}</span>
    </div>
    
    <div class="page-jump">
      <span class="page-text">{{$t('home.components.pagination.goto')}} </span>
      <input class="jump-page-input" v-model.number="jumpPage" name="page" type="text"/>
      <span class="page-text">{{$t('home.components.pagination.page')}} </span>
    </div>
    <div class="page-item mr-0" @click="goto(jumpPage)">
      <span class="btn btn-blue mr-0">{{$t('home.components.pagination.jump')}} </span>
    </div>
  </div>
</template>
<script>
export default {
  name:'pagination',
  props:{
    currentPage:{
      type: Number,
      default: 1
    },
    totalPages:{
      type: Number,
      default: 1
    }
  },
  watch: {
    jumpPage(val) {
      this.jumpPage = parseInt(val) > 0 ? parseInt(val) : ''
    }
  },
  data() {
    return {
      jumpPage:''
    }
  },
  methods: {
    goto(pageNumber){
      if(pageNumber > this.totalPages || pageNumber < 1) return;
      this.$emit("goto",pageNumber)
    }
  },
}
</script>

<style lang="sass" scoped>
  .pagination
    
    display: flex
    margin-top: 2rem
    .page-item 
      margin-right: 1rem
      margin-top: 0.7rem
      .page-link:focus
        box-shadow: none
      .page-link
        font-size: 1.2rem
        font-weight: 400
        color: #3F3A3A
        line-height: 1.7rem
        border-radius: 0.2rem
        padding: 0.6rem 1.2rem
        cursor: pointer
        border: 0.1rem solid #D9D8D8
      .current-page
        font-size: 1.2rem
        color: #DC472A
        line-height: 1.7rem
        padding-right: 0.4rem
        vertical-align: bottom
      .total-page
        font-size: 1.2rem
        color: rgba(63,58,58,1);
        line-height: 1.7rem;
        vertical-align: bottom
      .btn
        background: #DC472A
        border-radius: 0.2rem
        padding: 0.6rem 1.4rem
        font-size: 1.2rem
        font-weight: 400
        color: rgba(255,255,255,1)
        line-height: 1.7rem
        font-family: PingFang-SC-Regular, PingFang-SC
    .page-item.active .page-link 
      background-color: #DC472A
      border-color: #DC472A
      color: #fff
    .page-item.active .page-link:hover
      color: #fff
    .page-jump
      margin-right: 1rem
      .page-text
        font-size: 1.2rem
        font-weight: 400
        color: #999999
        line-height: 1.7rem
        margin: 0 0.5rem
      .jump-page-input
        width: 3.5rem
        height: 3rem
        border-radius: 0.2rem
        border: 0.1rem solid #D9D8D8
        text-align: center
        font-size: 1.2rem
        line-height: 1.7rem
      
</style>

